import i18n from "i18next"
 
/**
 * Кнопки за замовчуванням
 */
export const getButtonsDef = (t) => [
    {
        title       : t('common:buttons.ok'),
        variant     : 'primary',
        handleClick : () => { console.log('Click Dlg Button ')}

    }
]

/**
 * Базові набори кнопок
 * НІ / ТАК 
 * (без функцій)
 */
export const getButtonsNoYes = (t) => [
    {
        title       : t('common:buttons.no'),
        variant     : 'secondary'
    },

    {
        title       : t('common:buttons.yes'),
        variant     : 'primary'
    },
]


/**
 * Базові набори кнопок
 * НІ / ТАК (червона)
 * (без функцій)
 */
export const getButtonsNoYesDanger = (t) => [
    {
        title       : t('common:buttons.no'),
        variant     : 'secondary'
    },

    {
        title       : t('common:buttons.yes'),
        variant     : 'danger'
    },
]




/**
 * Базові набори кнопок
 * Відмінити / Ок
 * (без функцій)
 */
export const getButtonsCancelOk = (t) => [
    {
        title       : t('common:buttons.cancel'),
        variant     : 'secondary'
    },

    {
        title       : t('common:buttons.ok'),
        variant     : 'primary'
    },
]




/**
 * Визначаємо назву заголовку по типу діалогу
 */

export const getTitleByType = (typeDlg) => {
    return i18n.t(`ModalContext.typeDlg.${typeDlg||'info'}`);
}